module.exports = __webpack_public_path__ + "media/images/regional-image7-b4fc283ef33eb528f3f6c577ffe1d8ed.jpg";